'use client';

import React from 'react';
import { Card } from 'src/components/PulseUI';
import WidgetHeader from 'src/components/Profiles/shared/widgets/WidgetHeader';
import CompactTreatingVolumeRatioPreview from './CompactTreatingVolumeRatioPreview';

const CompactTreatingVolumeRatio: React.FC = () => {
  return (
    <Card
      className="p-5 flex flex-col gap-3 bg-white h-full"
      data-testid="compact-treating-volume-ratio"
      role="region"
    >
      <WidgetHeader fallbackTitle="Ratio Analysis" />
      <div className="flex-1 min-h-0 overflow-y-auto">
        <CompactTreatingVolumeRatioPreview />
      </div>
    </Card>
  );
};

export default CompactTreatingVolumeRatio;
